var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup432(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#fff;stroke:#fff;stroke-width:.5px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    transform: "translate(-.115 .082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_669",
    fill: "none",
    d: "M0 0H54V54H0z",
    transform: "translate(.115 -.082)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_002-invoice",
    transform: "translate(16.898 16.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_365"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    d: "M32.929 0H19.4a3.387 3.387 0 0 0-3.383 3.383v4.059a.677.677 0 0 0 .677.677h4.736v12.852a.607.607 0 0 0 .024.122.627.627 0 0 0 .024.13.652.652 0 0 0 .223.275.531.531 0 0 0 .068.045.63.63 0 0 0 .586.053l.012-.005 3.117-1.246 3.134 1.255a.671.671 0 0 0 .5 0l3.132-1.253 3.133 1.253a.677.677 0 0 0 .928-.629V3.383A3.387 3.387 0 0 0 32.929 0zm-11.5 6.765h-4.06V3.383a2.03 2.03 0 1 1 4.059 0zm13.53 13.208l-2.459-.982a.671.671 0 0 0-.5 0l-3.13 1.252-3.131-1.253a.671.671 0 0 0-.5 0l-2.456.982V3.383a3.343 3.343 0 0 0-.694-2.03h10.84a2.032 2.032 0 0 1 2.03 2.03z",
    className: "cls-2",
    transform: "translate(-16.016)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    transform: "translate(8.118 4.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    d: "M216.811 96h-8.118a.677.677 0 0 0 0 1.353h8.118a.677.677 0 0 0 0-1.353z",
    className: "cls-2",
    transform: "translate(-208.016 -96)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    transform: "translate(8.118 9.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_369"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    d: "M216.811 224h-8.118a.676.676 0 1 0 0 1.353h8.118a.676.676 0 1 0 0-1.353z",
    className: "cls-2",
    transform: "translate(-208.016 -224)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    transform: "translate(10.824 12.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    d: "M278.1 288h-5.412a.676.676 0 0 0 0 1.353h5.412a.676.676 0 1 0 0-1.353z",
    className: "cls-2",
    transform: "translate(-272.016 -288)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    transform: "translate(10.824 14.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_373"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    d: "M278.1 352h-5.412a.676.676 0 0 0 0 1.353h5.412a.676.676 0 1 0 0-1.353z",
    className: "cls-2",
    transform: "translate(-272.016 -352)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup432);
export default __webpack_public_path__ + "static/media/Group 432.b2f14ac444dc52b0b3e10dac9adc2b7e.svg";
export { ForwardRef as ReactComponent };